import styled from 'styled-components'

export const MenuItemWrapper = styled.div<{ $bg?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 35px;
  width: 100%;
  cursor: pointer;
  padding: 12px 16px;
  border: none;
  border-radius: 4px;

  &:hover {
    background: ${(props) => (props.$bg ? 'rgba(255, 255, 255, 0.1)' : 'transparent')};
  }
`

export const Label = styled.span`
  color: white;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
`

export const RadioButtonStyled = styled.div<{ $selected?: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.$selected ? '#4CAF50' : '#666')};
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: ${(props) => (props.$selected ? '#4CAF50' : 'transparent')};
  }
`
